import { ChangeDetectionStrategy, Component, input, model, OnInit, output } from '@angular/core';
import { SortingOption } from '@app/utils/interfaces/order.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ORDER_SORT_OPTIONS } from '@app/utils/constants/orders.constants';
import { SortOptionConfig } from '@app/utils/interfaces/sort-option.interface';

@Component({
  selector: 'app-table-sort',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule, TranslatePipe],
  templateUrl: './table-sort.component.html',
  styleUrl: './table-sort.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableSortComponent implements OnInit {
  public activeSortKey = model<string | null>('id-asc');
  public options = input<SortOptionConfig[]>(ORDER_SORT_OPTIONS);
  public sortChanged = output<SortingOption[]>();

  public ngOnInit(): void {
    this.emitSort();
  }

  public get currentSelectedOption(): SortOptionConfig | null {
    return this.options().find((option: SortOptionConfig) => option.key === this.activeSortKey()) || null;
  }

  public selectOption(key: string): void {
    this.activeSortKey.set(key);
    this.emitSort();
  }

  public clearSort(event: Event): void {
    event.stopPropagation();
    this.activeSortKey.set(null);
    this.sortChanged.emit([]);
  }

  public emitSort(): void {
    const selectedOption = this.options().find(option => option.key === this.activeSortKey());
    this.sortChanged.emit(selectedOption?.sorting ?? []);
  }
} 
